import * as Sentry from '@sentry/browser';

export enum withSentryStatus {
  OK = 'ok',
  UNKNOWN_ERROR = 'unknown_error',
}

export enum withSentryHttpStatus {
  OK = 200,
  INERNAL_ERROR = 502,
  NOT_FOUND_ERROR = 404,
}

export function WithSentryDecorator() {
  return (
    target: any,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<(...params: any[]) => Promise<any>>
  ) => {
    const func = descriptor.value!;
    const transactionName = `${func.name}__helper__0`;
    descriptor.value = async function () {
      return await Sentry.startSpanManual(
        {
          name: transactionName,
        },
        async (span) => {
          try {
            const result = await func.apply(this, arguments);
            const stringifiedArguments = JSON.stringify(arguments);
            const stringifiedResult = JSON.stringify(result);
            span.setAttribute('arguments', stringifiedArguments);
            span.setAttribute('result', stringifiedResult);
            span.setStatus(
              Sentry.getSpanStatusFromHttpCode(withSentryHttpStatus.OK)
            );
            return result;
          } catch (error) {
            span.setAttribute('error', JSON.stringify(error));
            span.setStatus(
              Sentry.getSpanStatusFromHttpCode(
                withSentryHttpStatus.INERNAL_ERROR
              )
            );
            throw new Error(error);
          } finally {
            span.end();
          }
        }
      );
    };
  };
}
